import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL, FILE_URL } from '../constants';

const FileUpload = ({ fileType, defaultId, defaultUrl, defaultExt, onChange, authToken, debug = false, error = false, setUrl = false }) => {
  const [file, setFile] = useState(null);
  const [response, setResponse] = useState(null);
  const [errorFile, setErrorFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (e, fileType) => {
    const selectedFile = e.target.files[0];
    e.preventDefault();

    if (selectedFile.size > 1 * 1024 * 1024) {
      setErrorFile('File size exceeds 1 MB');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('docof', 'vendor');

    try {
      setErrorFile(null);
      setLoading(true);

      const res = await axios.post(`${API_URL}/media/vendor`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${authToken}`,
        }
      });

      if (res.data.status === 'failed' && res.data.error) {
        setErrorFile(res.data.error);
        setLoading(false);
        return;
      }

      setResponse(res.data);
      onChange(setUrl ? res.data?.file_urls?.full || '' : res.data?.id || '', fileType);
    } catch (err) {
      setErrorFile('Failed to upload file');
    }

    setLoading(false);
    setFile(selectedFile);
  };

  const handleRemove = () => {
    setFile(null);
    setResponse(null);
    setErrorFile(null);
  };

  const renderPreview = (fileData, fileUrl) => {
    if (!fileData || !fileData.file_urls) return null;

    const fileExt = fileData.ext;
    const fileFullUrl = `${FILE_URL}${fileUrl}`;

    if (fileExt === 'mp4') {
      return (
        <div>
          <video className="filepreview" controls width="100" height="100">
            <source src={fileFullUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      );
    } else {
      return (
        <div>
          <img className="filepreview" src={fileFullUrl} alt="Preview" style={{ maxWidth: '100px', height: '100px' }} />
        </div>
      );
    }
  };

  useEffect(() => {
    if (defaultId && defaultUrl) {
      setLoading(true);
      setResponse({
        id: defaultId,
        file_urls: { full: defaultUrl },
        ext: defaultExt
      });
      setLoading(false);
    }
  }, [defaultId, defaultUrl, defaultExt]);

  return (
    <div>
      <input
        className={`${fileType}file custom-file form-control`}
        type="file"
        onChange={(e) => handleFileChange(e, fileType)}
      />
      <div>
        {loading && <span className="text-info small">Loading preview...</span>}
        {renderPreview(response, response?.file_urls?.full)}
        <input
          className={fileType}
          type="hidden"
          name={fileType}
          value={setUrl ? response?.file_urls?.full || '' : response?.id || ''}
        />
        {response?.file_urls?.full && response?.id && (
          <button
            type="button"
            className={`btn btn-primary ${fileType}remove`}
            onClick={handleRemove}
          >
            Remove
          </button>
        )}
        {errorFile && <span className="text-danger small">{errorFile}</span>}
        {debug && !response && !errorFile && (
          <span className="text-info small">Debugging Mode</span>
        )}
      </div>
      {defaultUrl && !response && !errorFile && (
        <div>
          {defaultExt === 'mp4' ? (
            <video className="filepreview" controls width="100" height="100">
              <source src={defaultUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img className="filepreview" src={defaultUrl} alt="Preview" style={{ maxWidth: '100px', height: '100px' }} />
          )}
        </div>
      )}
    </div>
  );
};

export default FileUpload;
